import React from "react";
const Kebijakan = React.lazy(() => import('./kebijakan'));

export const kebijakanPagesConfig = [
    {
        path: '/kebijakan',
        element:<Kebijakan />
    },
    {
        path: '/kebijakan/:jenis',
        element:<Kebijakan />
    },
    {
        path: '/kebijakan/:jenis/:id',
        element:<Kebijakan />
    },
    {
        path: '/kebijakan/:jenis/detail/:id',
        element:<Kebijakan isDetail='detail' />
    }
];